import React, { Fragment, memo, useContext, useEffect, useState } from "react";

// Utils

// UI
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import { Container, DateLayer, closeLayerFn, openLayerFn } from "../../Layout";
import { SUBS, SubMenu } from "../Pmr";
import {
  ListView,
  PeriodSetting,
  SelectArea,
  checkMsgCount,
  commonFileUpload,
  fileDelete,
  request551,
  request554,
  request555,
} from "../PmrLayout";

// Provider
import {
  AppContext,
  SET_PAGE_STATE,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";
import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { PostApi1913 } from "../../../modules/network/padoPost";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { userHabit } from "../../../modules/utils/UserHabit";
import { reLogin } from "../../common/AutoLogin/AutoLogin";

export default memo(props => {
  const { auth, userinfo, cfg, phonecfg, dispatch, pageState } =
    useContext(AppContext);

  // msgCount
  const [msgCount, setMsgCount] = useState("");

  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[0];

  const [periodIndex, setPeriodIndex] = useState(2);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [pdhType, setPdhType] = useState(2);
  const [hpCode, setHpCode] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [modalityName, setModalityName] = useState("");
  const [trsmId, setTrsmId] = useState();

  const [list, setList] = useState(null);
  const [hospitalList, setHospitalList] = useState("");
  const [modalityList, setModalityList] = useState("");

  // 임시
  const [trgtHsptList, setTrgtHsptList] = useState([]);

  // 공유버튼 활성화 상태 0:비활성화, 1:활성화

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  const handleAlert = () => {
    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const openConfirmLayer = trsmId => {
    openLayerFn($(".confirm-layer"));
    setTrsmId(trsmId);
  };

  const fnConfirmLayer = () => {
    fileDelete(userinfo, trsmId);
  };

  const fnCancelConfirmLayer = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const reloadList = () => {
    request551(
      reLogin(auth, userinfo, dispatch),
      cfg,
      phonecfg,
      periodIndex,
      hpCode,
      modalityName,
      startDate,
      endDate,
      pdhType,
      "N",
      setList
    );
  };

  const socketConnection = trsmId => {
    if (phonecfg.phoneOS === "ANDROID") {
      // 안드로이드인 경우 2.0.30 이상
      if (parseInt(phonecfg.version.split(".")[2]) >= 41) {
        commonFileUpload(
          reloadList,
          userinfo,
          trsmId,
          2,
          "Y",
          "PR",
          "개인진료기록"
        );
      } else {
        // socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {"userToken":userinfo.userToken, "masterKeys":[{"masterKey1":trsmId.toString(), "masterKey2":""}]});
        socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {
          userToken: userinfo.userToken,
          trsmId: trsmId.toString(),
        });
      }
    } else {
      // IOS인 경우 2.0.31 이상
      if (parseInt(phonecfg.version.split(".")[2]) >= 21) {
        commonFileUpload(
          reloadList,
          userinfo,
          trsmId,
          2,
          "Y",
          "PR",
          "개인진료기록"
        );
      } else {
        // socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {"userToken":userinfo.userToken, "masterKeys":[{"masterKey1":trsmId.toString(), "masterKey2":""}]});
        socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {
          userToken: userinfo.userToken,
          trsmId: trsmId.toString(),
        });
      }
    }
  };

  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result.sharHsptList.length > 0) {
            setTrgtHsptList(res.result.sharHsptList);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    // 최초 초기화
    dispatch({ type: SET_PAGE_STATE, data: { type: "all", state: 0 } });
  }, []);

  useEffect(() => {
    userHabit(phonecfg, "PR110");
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, [phonecfg.version]);

  useEffect(() => {
    checkMsgCount(
      userinfo2,
      cfg,
      phonecfg,
      "9",
      "00000000",
      "99999999",
      setMsgCount
    );
    request551(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      hpCode,
      modalityName,
      startDate,
      endDate,
      pdhType,
      "N",
      setList
    );

    if (pageState.share == 0) {
      $(".longTap").removeClass("none");
      $("#confirmCheck").hide();
      $(".check-box2").hide();
      $("input:checkbox").prop("checked", false);
    }
  }, [
    periodIndex,
    startDate,
    endDate,
    pdhType,
    hpCode,
    modalityName,
    pageState.share,
    pageState.reload,
  ]);

  useEffect(() => {
    request554(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      startDate,
      endDate,
      pdhType,
      setHospitalList
    );
    request1913(userinfo2, cfg, phonecfg);
  }, [periodIndex, startDate, endDate, pdhType]);

  useEffect(() => {
    request555(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      startDate,
      endDate,
      pdhType,
      setModalityList
    );
  }, [periodIndex, startDate, endDate, pdhType, hpCode]);

  useEffect(() => {
    if (pageState.reload === 1) {
      checkMsgCount(
        userinfo2,
        cfg,
        phonecfg,
        "9",
        "00000000",
        "99999999",
        setMsgCount
      );
      request551(
        userinfo2,
        cfg,
        phonecfg,
        periodIndex,
        hpCode,
        modalityName,
        startDate,
        endDate,
        pdhType,
        "N",
        setList
      );

      if (pageState.share == 0) {
        $(".longTap").removeClass("none");
        $("#confirmCheck").hide();
        $(".check-box2").hide();
        $("input:checkbox").prop("checked", false);
      }
      dispatch({ type: SET_PAGE_STATE, data: { type: "reload", state: 0 } });
    }
  }, [pageState.reload]);

  useEffect(() => {
    window.webReload = new CustomEvent("NativeEvent");
    const nativeEventCallback = event => {
      checkMsgCount(
        userinfo2,
        cfg,
        phonecfg,
        "9",
        "00000000",
        "99999999",
        setMsgCount
      );
      request551(
        userinfo2,
        cfg,
        phonecfg,
        periodIndex,
        hpCode,
        modalityName,
        startDate,
        endDate,
        pdhType,
        "N",
        setList
      );
    };

    window.addEventListener("NativeEvent", nativeEventCallback);

    // event listener clean up
    return () => {
      window.removeEventListener("NativeEvent", nativeEventCallback);
    };
  }, []);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="영상자료"
        msgCount={msgCount}
        container="container"
        goToUrl="/pmr"
        color="purple">
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} />
          {/* /subTabMenu */}

          {/* BODY */}
          <div className="pr-section">
            <div className="half-round-bgbox">
              {/* 기간 설정 */}
              <PeriodSetting setPeriodIndex={setPeriodIndex} />
              {/* / 기간설정 */}

              <SelectArea
                hospitalList={hospitalList}
                modalityList={modalityList}
                hospitalName={hospitalName}
                setHpCode={setHpCode}
                setModalityName={setModalityName}
                trgtHsptList={trgtHsptList}
              />
            </div>
          </div>

          {/* {list != null && list.length > 0 && (
              <PillBtnArea>
                {pageState.share === 0 ? (
                  <BtnTypePill text={"선택"} onClick={() => clickBtnEvent()} />
                ) : (
                  <Fragment>
                    <BtnTypePill
                      text="취소"
                      id="restoreMode"
                      onClick={() => resetChecked()}
                    />
                    <BtnTypePill
                      text="전체선택"
                      id="checkAll"
                      onClick={() => checkedAll()}
                    />
                    <BtnTypePill
                      text="전체해제"
                      id="unCheckAll"
                      display="none"
                      onClick={() => unCheckedAll()}
                    />
                  </Fragment>
                )}
              </PillBtnArea>
            )} */}

          <div className="sub-contents">
            {/* 영상 리스트 */}
            <ListView
              type="VIDEO"
              pdhType={pdhType}
              list={list}
              userToken={userinfo.userToken}
              openConfirmLayer={openConfirmLayer}
              returnUrl="pmr/history"
              reloadList={reloadList}
              socketConnection={socketConnection}
            />
          </div>
          {/* //BODY */}
        </div>
      </Container>
      <DateLayer handleDate={handleDate} />
      <AlertLayer
        priv="priv"
        title="서비스 준비중"
        msg="서비스 준비중 입니다."
        handleConfirmCB={handleAlertCB}
      />
      <ConfirmLayer
        priv="priv"
        title="개인진료기록 삭제"
        msg="삭제한 파일은 다시 복구할 수 없습니다. <br /> 정말 삭제 하겠습니까?"
        handleCancelCB={fnCancelConfirmLayer}
        handleConfirmCB={fnConfirmLayer}
      />
    </Fragment>
  );
});
